const state = {
    consents: {
        pending: [],
        manageable: [],
        leaflet: null
    },
    campaignConsents: [],
    resignationReasons: []
}

const getters = {
    consentsStructure(state) {
        return state.consents
    },

    availablePendingConsentsTypes(state) {
        return state.campaignConsents.map(item => {
            return item.type
        })
    },

    isPendingChanged(state) {
        const itemsChecked = state.consents.pending.filter(item => item.isGranted === true).length
        const itemsCheckedAndFilled = state.consents.pending.filter(item => item.isGranted === true && item.value.length > 0).length

        console.log(itemsChecked, itemsCheckedAndFilled)

        return (state.consents.leaflet === true && itemsChecked === 0) || (itemsChecked > 0 && itemsChecked === itemsCheckedAndFilled)
    },

    hasResignations(state) {
        return state.consents.manageable.filter(item => item.isGranted != true).length > 0
    },

    resignationReasons(state) {
        return state.resignationReasons
    },

    customerContactData(state) {
        let out = {}

        state.consents.pending.forEach(item => {
            if (item.isGranted) {
                out[item.type] = item.value
            }
        })

        state.consents.manageable.forEach(item => {
            if (item.isGranted) {
                out[item.type] = item.value
            }
        })

        return out
    }
}

const mutations = {
    clear(state) {
        state.consents = {
            pending: [],
            manageable: [],
            leaflet: null
        }
    },

    setConsents(state, { pending, manageable, leaflet }) {
        state.consents = {
            pending,
            manageable,
            leaflet
        }
    },

    setLeafletConsent(state, value) {
        state.consents.leaflet = value
    },

    setCampaignConsents(state, consents) {
        state.campaignConsents = consents
    },

    setResignationReasons(state, value) {
        state.resignationReasons = value
    },

    addPendingConsent(state, params) {
        state.consents.pending.push({
            type: params.type,
            isGranted: false,
            value: ''
        })
    },

    addManageableConsent(state, params) {
        state.consents.manageable.push({
            type: params.type,
            isGranted: params.value > 0,
            value: ''
        })
    },

    updatePendingConsent(state, params) {
        let matches = state.consents.pending.filter(item => item.type === params.type)

        if (matches.length > 0) {
            matches[0] = Object.assign(matches[0], {
                isGranted: params.isGranted || false,
                value: params.value || ''
            })

            return true
        }
    },

    updateManageableConsent(state, params) {
        console.log(params)

        let matches = state.consents.manageable.filter(item => item.type === params.type)

        if (matches.length > 0) {
            let match = matches[0]

            const isGranted = params.isGranted == true ? true : false
            const value = params.value || match.value
            const resignationReason = params.resignationReason ? params.resignationReason : (params.resignationReason === 0 ? 0 : '')
            const resignationReasonOther = !resignationReason && params.resignationReasonOther ? params.resignationReasonOther : ''

            match = Object.assign(match, {
                isGranted,
                value,
                resignationReason,
                resignationReasonOther
            })

            return true
        }
    },

    restoreAllManageableConsents(state) {
        for (let i = 0; i < state.consents.manageable.length; i++) {
            state.consents.manageable[i].isGranted = true
        }
    }
}

const actions = {
    clear({ commit }) {
        commit('clear')
    },

    resolve({ commit, getters }, { consents, leaflet }) {
        let pending = []
        let manageable = []
        let leafletConsent = leaflet === true ? null : false

        consents.forEach(consent => {
            if (consent.statusCd > 0) {
                manageable.push({
                    type: consent.type,
                    isGranted: consent.statusCd > 0 ? true : false,
                    value: consent.value,
                    resignationReason: '',
                    resignationReasonOther: ''
                })
            }
            else {
                if (getters['availablePendingConsentsTypes'].indexOf(consent.type) > -1) {
                    pending.push({
                        type: consent.type,
                        isGranted: false,
                        value: ''
                    })
                }
            }
        })

        commit('setConsents', { pending, manageable, leaflet: leafletConsent })
    },

    setCampaignConsents({ commit }, consents) {
        commit('setCampaignConsents', consents)
    },

    setResignationReasons({ commit }, value) {
        commit('setResignationReasons', value)
    },

    setLeafletConsent({ commit }, value) {
        commit('setLeafletConsent', value)
    },

    updateStructure({ commit }, params) {
        if (params.value === '-1') {
            state.consents.manageable = state.consents.manageable.filter(item => item.type !== params.type)

            if (state.consents.pending.filter(item => item.type === params.type).length > 0) {
                return
            }
            
            commit('addPendingConsent', params)
        }
        else {
            state.consents.pending = state.consents.pending.filter(item => item.type !== params.type)

            const updatedItem = state.consents.manageable.filter(item => item.type === params.type)

            if (updatedItem.length > 0) {
                updatedItem[0].isGranted = params.value > 0
            }
            else {
                commit('addManageableConsent', params)
            }
        }
    },

    updatePendingConsent({ commit }, params) {
        commit('updatePendingConsent', params)
    },

    updateManageableConsent({ commit }, params) {
        commit('updateManageableConsent', params)
    },

    restoreAllManageableConsents({ commit }) {
        commit('restoreAllManageableConsents')
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}